import { mdiAlert, mdiAlertCircle, mdiCheck } from '@mdi/js'
import { Icon } from '@mdi/react'
import { Spinner } from 'components/Loader'
import { ProgressCircle } from 'components/ProgressCircle'

import theme from 'theme_'

import {
  StyledStateWrapper,
  StyledErrorStateMessage,
  StyledStateMessage,
} from './styles'

interface WithMessageStatusProps {
  message?: string
  progress?: null | number
}

interface StatusProps {
  icon: JSX.Element
  message: JSX.Element
}

function Status({ icon, message }: StatusProps) {
  return (
    <StyledStateWrapper>
      {icon}
      {message}
    </StyledStateWrapper>
  )
}

export function SuccessStatus() {
  const icon = <Icon path={mdiCheck} size={0.8} color={theme.colors.green} />
  const message = <StyledStateMessage>Success</StyledStateMessage>

  return <Status icon={icon} message={message} />
}

export function ErrorStatus(props: WithMessageStatusProps) {
  const icon = <Icon path={mdiAlert} size={0.8} color={theme.colors.error} />
  const message = (
    <StyledErrorStateMessage>{props.message}</StyledErrorStateMessage>
  )

  return <Status icon={icon} message={message} />
}

export function DownloadStatus(props: WithMessageStatusProps) {
  const icon = props.progress ? (
    <ProgressCircle percent={props.progress} size={2} />
  ) : (
    <Spinner size={1} />
  )
  const message = <StyledStateMessage>{props.message}</StyledStateMessage>
  return <Status icon={icon} message={message} />
}

export function ReadyStatus(props: WithMessageStatusProps) {
  return (
    <StyledStateWrapper>
      <StyledStateMessage>{props.message}</StyledStateMessage>
    </StyledStateWrapper>
  )
}

export function InstallStatus(props: WithMessageStatusProps) {
  const icon = props.progress ? (
    <ProgressCircle percent={props.progress} size={2} />
  ) : (
    <Spinner size={1} />
  )
  const message = <StyledStateMessage>{props.message}</StyledStateMessage>

  return <Status icon={icon} message={message} />
}

export function NewStatus() {
  const icon = (
    <Icon
      path={mdiAlertCircle}
      size={0.8}
      color={theme.colors.otterWarmBlack}
    />
  )
  const message = <StyledStateMessage>New</StyledStateMessage>

  return <Status icon={icon} message={message} />
}

export function RebootStatus(props: WithMessageStatusProps) {
  const icon = <Spinner size={1} />
  const message = <StyledStateMessage>{props.message}</StyledStateMessage>

  return <Status icon={icon} message={message} />
}
